module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img05-a40d54bb06355d8f1ae77533345e7ec5.svg";